<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="container">
    <div class="row qa-part">
      <div class="col-md-12 subtitle-container">
        <h1>FAQS For Loaner</h1>
      </div>
      <div
        class="col-md-12"
        style="margin-left: 15px;"
      >
        <collapsible-q-a>
          <template v-slot:question>
            <strong>1. How long does it take to get approved?</strong>
          </template>
          <template v-slot:answer>
            <label>Generally 12 to 24 hours.</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>2. What are the conditions of a loan?</strong>
          </template>
          <template v-slot:answer>
            <label>
              In order to get a loan, please submit your application online
              <router-link :to="{name: 'borrow-form', params: {formType: 'borrow'}}">(link here)</router-link>
              . We provide loan to any Cambodian citizen, age 18-50 years old, can provide proof of monthly income, that
              live in Phnom Penh, Siem Reap, Sihanoukville Province.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>3. What information are required to apply?</strong>
          </template>
          <template v-slot:answer>
            <label>
              You will need to fill out the application form
              <router-link :to="{name: 'borrow-form', params: {formType: 'borrow'}}">(link here)</router-link>
              and <strong>provide Personal Information</strong>, <strong>Employment Information</strong>, and <strong>Relative
                Information</strong>.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>4. What is the difference between payday and personal loan?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Payday loan has a shorter loan term, usually 10 to 30 days and paid off with one payment. Personal loan
              has a longer loan term, usually 1 to 6 months and can be paid off monthly.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>5. How much can I borrow?</strong>
          </template>
          <template v-slot:answer>
            <label>No answer</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>6. I am running a business, can I apply for a loan?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Yes. We would require a history of income or collateral. We will also need to understand the reason for a
              loan and the business you are operating.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>7. Is there any loan for students?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Yes. If you earn a monthly income of $200 USD and have a university student ID.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>8. Is there a preferential rate for students?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Yes. Cash Hero provides preferential rate to students.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>9. I am from a province that is neither Siem Reap, Phnom Penh, and Sihanoukville, can I apply for a
              loan?</strong>
          </template>
          <template v-slot:answer>
            <label>Yes, approval rate is lower.</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>10. How do you charge?</strong>
          </template>
          <template v-slot:answer>
            <label>
              We will charge an <strong>interest rate</strong>, <strong>consulting fee</strong>, and <strong>processing
                fee</strong>. Please check the the amount calculated on our website. <a href="/">(link to front page
                here)</a>
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>11. Do I need a reference to loan?</strong>
          </template>
          <template v-slot:answer>
            <label>Yes, your reference will help us determine your credibility. </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>12. Where is Cash Hero located?</strong>
          </template>
          <template v-slot:answer>
            <label>We are located at street 122, Khan Toul Kork, Phnom Penh, Cambodia. Please contact us at <a
              href="mailto:info@cashherokh.com"
              target="_blank"
            >cashhero@gmail com</a>, Tel: <span
              class="label-color-blue"
            >070360289</span> or chat to us live on our website.</label>
          </template>
        </collapsible-q-a>
      </div>
    </div>
    <div class="row qa-part">
      <div class="col-md-12 subtitle-container">
        <h1>FAQS For Investors</h1>
      </div>
      <div
        class="col-md-12"
        style="margin-left: 15px;"
      >
        <collapsible-q-a>
          <template v-slot:question>
            <strong>1. How do I invest with Cash Hero?</strong>
          </template>
          <template v-slot:answer>
            <label>Please submit your information via the Investor application form. <router-link to="/invest-form">(Link
              here)</router-link></label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>2. What is the minimum investment amount?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Minimum investment is $5k to $15K USD.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>3. How much is the return on the investment?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Please see the table at our investment page (link here)
            </label>
            <div class="row">
              <div class="col-md-6">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Investment Amount</th>
                      <th>Annual Return Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>$5k to $15k</td>
                      <td>10%</td>
                    </tr>
                    <tr>
                      <td>$15k to $25k</td>
                      <td>11%</td>
                    </tr>
                    <tr>
                      <td>$25k to $50k</td>
                      <td>12%</td>
                    </tr>
                    <tr>
                      <td>$50K <sup>+</sup></td>
                      <td>Let's discuss</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>4. What is the minimum investment duration?</strong>
          </template>
          <template v-slot:answer>
            <label>One year or 12 months</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>5. When is my return on investment calculated?</strong>
          </template>
          <template v-slot:answer>
            <label>
              Return on investment is calculated and updated quarterly. You can request you fund back after being an
              investor for a year.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>6. How do I request my fund?</strong>
          </template>
          <template v-slot:answer>
            <label>
              We will provide a VIP phone number to our selected investors. You will be able to reach us anytime to
              deposit or withdrawal. Please note that the amount transfer will not include potential fees such as bank
              fee, transfer fee, foreign exchange fee or taxes.
            </label>
          </template>
        </collapsible-q-a>
      </div>
    </div>
  </div>
</template>

<script>
import CollapsibleQA from './../../CollapsibleQA'

export default {
  name: 'FaqEnglish',
  components: { CollapsibleQA }
}
</script>

<style scoped>

</style>
